import { Typography } from "@/components/typography";

const RelatedItemHeading = () => (
  <div className="flex gap-4 my-3">
    <div className="bg-red w-2  rounded-md" />
    <Typography
      tag="h3"
      className="leading-5 tracking-wider text-red font-semibold "
    >
      Related Items
    </Typography>
  </div>
);

export default RelatedItemHeading;
